// Focus trap helpers exposed on window for drawers/modals
(function () {
  function enableFocusTrap(container) {
    window._focusTrap = window._focusTrap || {
      container: null,
      lastActive: null,
      handler: null,
    };
    try {
      if (window._focusTrap.handler)
        document.removeEventListener(
          "keydown",
          window._focusTrap.handler,
          true,
        );
    } catch (e) {}
    window._focusTrap.container = container;
    window._focusTrap.lastActive = document.activeElement;
    const selector =
      'a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])';
    const nodes = Array.prototype.slice
      .call(container.querySelectorAll(selector))
      .filter(
        (el) => el.offsetWidth || el.offsetHeight || el.getClientRects().length,
      );
    const first = nodes[0];
    const last = nodes[nodes.length - 1];
    try {
      if (first) first.focus();
      else container.focus();
    } catch (e) {}
    window._focusTrap.handler = function (e) {
      if (e.key !== "Tab") return;
      if (nodes.length === 0) {
        e.preventDefault();
        return;
      }
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };
    document.addEventListener("keydown", window._focusTrap.handler, true);
  }

  function disableFocusTrap() {
    try {
      if (window._focusTrap && window._focusTrap.handler)
        document.removeEventListener(
          "keydown",
          window._focusTrap.handler,
          true,
        );
    } catch (e) {}
    try {
      if (
        window._focusTrap &&
        window._focusTrap.lastActive &&
        window._focusTrap.lastActive.focus
      )
        window._focusTrap.lastActive.focus();
    } catch (e) {}
    window._focusTrap = { container: null, lastActive: null, handler: null };
  }

  window.enableFocusTrap = enableFocusTrap;
  window.disableFocusTrap = disableFocusTrap;
})();
